// import RepositoryFactory from "@/apis";
// const achievement = RepositoryFactory.achievement;
import achievement from "../../apis/achievement";

export default {
  addAchievement({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await achievement.addAchievement(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAchievement({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await achievement.getAchievement(payload);
        commit("SET_ACHIEVEMENT", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getAchievementById({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await achievement.getAchievementById(payload);
        commit("EDIT_ACHIEVEMENT", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editAchievement({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log('edit ach')
        const { data } = await achievement.editAchievement(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteAchievement({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await achievement.deleteAchievement(payload);
        // commit("SET_ACHIEVEMENT",  data.data );

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
